import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { SourceLoadingComponent } from '@3dsource/source-ui-native';
import { GlobalLoadingStore } from './store/global-loading.store';

@Component({
  selector: 'app-global-loading',
  templateUrl: './global-loading.component.html',
  styleUrl: './global-loading.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SourceLoadingComponent],
  providers: [GlobalLoadingStore],
})
export class GlobalLoadingComponent {
  private globalLoadingStore = inject(GlobalLoadingStore);
  readonly message = this.globalLoadingStore.message;
  readonly progress = this.globalLoadingStore.progress;
}
